<template>
  <tiptap-vuetify
    v-model="html"
    :extensions="extensions"
    :placeholder="placeholder"
    :id="elementId"
    :class="className"
    min-height="100"
  >
    <template v-slot:toolbar-after>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="ml-2"
            v-bind="attrs"
            v-on="on"
            @click="viewSourceCode"
          >
            <v-icon v-if="!showRawHTML">mdi-code-tags</v-icon>
            <v-icon v-else>mdi-subdirectory-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>{{ !showRawHTML ? "View source code" : "Back" }}</span>
      </v-tooltip>
      <v-textarea
        v-if="showRawHTML"
        v-model="html"
        class="html-editor__textarea"
        auto-grow
      ></v-textarea>
    </template>
  </tiptap-vuetify>
</template>

<script>
import ImageSelector from "@/components/editor/ImageSelector.vue";
import _ from "lodash";
import {
  Blockquote,
  Bold,
  BulletList,
  HardBreak,
  Heading,
  History,
  HorizontalRule,
  Image,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Paragraph,
  Strike,
  TiptapVuetify,
  Underline,
} from "tiptap-vuetify";

export default {
  name: "html-editor",
  components: { TiptapVuetify, ImageSelector },
  props: {
    value: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {
      showRawHTML: false,
      elementId: "",
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        [
          Image,
          {
            options: {
              imageSources: [
                { component: ImageSelector, name: "Image Upload" },
              ],
              imageSourcesOverride: true,
            },
          },
        ],
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3, 4, 5, 6],
            },
          },
        ],
        Bold,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  mounted() {
    this.value = this.html;
    this.elementId = _.uniqueId("html-editor-");
  },
  methods: {
    viewSourceCode() {
      this.showRawHTML = !this.showRawHTML;
      document
        .querySelector(`#${this.elementId} .tiptap-vuetify-editor__content`)
        .classList.toggle("d-none");
      document
        .querySelector(`#${this.elementId} .v-toolbar__content`)
        .classList.toggle("d-none");
    },
  },
  computed: {
    html: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style lang="scss">
.tiptap-vuetify-editor {
  .v-card {
    min-height: 200px;
    resize: vertical;
    overflow: auto;
  }
}

.tiptap-vuetify-editor__toolbar {
  top: 0;
  position: sticky;
  z-index: 2;
}

.html-editor__textarea {
  margin: 0 15px;
}

.html-body-error {
  border: 2px solid #ff5252;
  border-radius: 4px;
}

.html-body-error--detail {
  font-size: 0.75rem;
}

.html-icon {
  display: flex;
  align-self: flex-start;
  margin-top: 10px;
}
</style>
